import { Provider } from './Provider.js';
import * as amplitude from '@amplitude/analytics-browser';

class AmplitudeProvider extends Provider {
  track(_ref) {
    let {
      eventName,
      payload
    } = _ref;
    if (typeof amplitude !== 'undefined' && eventName) {
      const completePayload = {
        ...this.commonPayload,
        ...payload
      };
      amplitude.track(eventName, {
        ...this.commonPayload,
        ...payload
      });
      const isEmptyPayload = Object.keys(completePayload).length === 0;
      let debugMessage = `Send Amplitude event "${eventName}"`;
      if (!isEmptyPayload) {
        debugMessage = `${debugMessage} with payload: ${JSON.stringify(completePayload)}`;
      }
      this.logger.log(debugMessage);
    } else {
      this.logger.error('Cannot track with Amplitude, maybe it is not loaded?');
    }
  }
  setUserId(userId) {
    if (typeof amplitude !== 'undefined') {
      amplitude.setUserId(userId);
      this.logger.log(`User id set with value ${userId}`);
    }
  }
  setUserProperties(_ref2) {
    let {
      properties
    } = _ref2;
    if (typeof amplitude !== 'undefined') {
      const identify = new amplitude.Identify();
      properties.forEach(_ref3 => {
        let {
          key,
          value
        } = _ref3;
        identify.set(key, value);
        this.logger.log(`Setting user property ${key} with value ${value}`);
      });
      amplitude.identify(identify);
      this.logger.log('User properties set');
    }
  }
  init(key, configuration) {
    // Default config sends events on its own that would duplicate what we already do in the apps
    // with our own props, so disabling until we can analyze each case and see if we want to use them
    // https://amplitude.com/docs/sdks/analytics/browser/browser-sdk-2#autocapture
    const autocaptureConfig = {
      attribution: false,
      pageViews: false,
      sessions: false,
      formInteractions: false,
      fileDownloads: false,
      elementInteractions: false
    };
    amplitude.init(key, {
      ...configuration,
      autocapture: autocaptureConfig
    });
    this.logger.log(`Amplitude initialized with API Key: ${key}`);
  }
}

export { AmplitudeProvider };
//# sourceMappingURL=AmplitudeProvider.js.map
